import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const notificationTypes = [
  'follow_request',
  'like',
  'comment',
  'reply',
  'mention',
  'post',
  'repost',
  'tag'
];

const initialSettings = {
  follow_request: false,
  like: false,
  comment: false,
  reply: false,
  mention: false,
  post: false,
  repost: false,
  tag: false
};

const useNotificationSettings = (user) => {
  const [notificationSettings, setNotificationSettings] = useState(initialSettings);

  useEffect(() => {
    const fetchNotificationSettings = async () => {
      try {
        const userDoc = doc(db, 'users', user.uid);
        const docSnapshot = await getDoc(userDoc);
        if (docSnapshot.exists()) {
          const settings = docSnapshot.data().notificationSettings;
          setNotificationSettings(settings);
        } else {
          setNotificationSettings(initialSettings);
        }
      } catch (error) {
        console.error('Error fetching notification settings:', error);
      }
    };

    if (user) {
      fetchNotificationSettings();
    }
  }, [user]);

  const updateLocalNotificationSettings = (type) => {
    setNotificationSettings((prevSettings) => ({
      ...prevSettings,
      [type]: !prevSettings[type],
    }));
  };

  return {
    notificationSettings,
    updateLocalNotificationSettings,
  };
};

export default useNotificationSettings;